import React, {useState} from "react";

export const useTabs = (initialTab: number = 0) => {
    const [selectedTab, setSelectedTab] = useState(initialTab);
    const handleTabChange = (event: React.SyntheticEvent, index: number) => setSelectedTab(index);

    return [selectedTab, handleTabChange] as const;
};
